import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "@src/utils/baseQuery";
import { APIResponse } from "./CommonApiSlice";

export interface InterviewQuestionData {
  questionNo: number;
  question: string;
  answer: string;
  totalMarks: number;
  totalScore: number;
}

export interface InterviewData {
  technicalKnowledge: number;
  communication: number;
  problemSolving: number;
  questionDataList: InterviewQuestionData[];
}

export interface AddInterviewDataPayload {
  resourceId: string;
  resourceType: string;
  batchRef: string;
  interviewDataList: InterviewData[];
}

export interface GetInterviewDataParams {
  resourceId: string;
  resourceType: string;
  batchId: string;
  studentId: string;
}

export const InterviewApiSlice = createApi({
  reducerPath: "interviewApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    addInterviewData: builder.mutation<APIResponse, AddInterviewDataPayload>({
      query: (payload) => ({
        url: "student/add-interview-data",
        method: "POST",
        body: payload,
      }),
    }),
    getInterviewData: builder.query<any, GetInterviewDataParams>({
      query: ({ resourceId, resourceType, batchId, studentId }) => ({
        url: `student/get-interview-data`,
        method: "GET",
        params: { resourceId, resourceType, batchId, studentId },
      }),
    }),
  }),
});

export const {
  useAddInterviewDataMutation,
  useGetInterviewDataQuery,
  useLazyGetInterviewDataQuery,
} = InterviewApiSlice;